module.exports = __webpack_public_path__ + "static/media/Fern Partners.7bd5ad6c.webp";